module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/FILM STUDIES-MEDIA STUDIES-CREATIVE ARTS-a90f1f328654402c476dca46f2a87971.png";